<div>
  <div class="stars">
    @for (i of data; track i) {
      <mat-icon class="star" svgIcon="icon_star" />
    }
    <div class="foreground" [style.width.%]="(value / scale) * 100">
      @for (i of data; track i) {
        <mat-icon class="star" svgIcon="icon_star" />
      }
    </div>
  </div>
  <span class="votes">{{ votes }}</span>
</div>
